import React, { Component, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import makeCancellablePromise from 'make-cancellable-promise';
import { collection, getDoc, getDocs, doc, query, limit } from 'firebase/firestore';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { toast } from 'react-toastify';

import Loading from './../components/Loading';
import { auth, db } from './../helper/firebase';

const Login = React.lazy(() => import('./Login/Login')),
// const Login = React.lazy(() => {
//         return new Promise(resolve => {
//           setTimeout(() => resolve(import('./Login/Login')), 300000);
//         });
//       }),
      Dashboard = React.lazy(() => import('./Dashboard/Dashboard'));

class App extends Component{
  constructor(){
    super();
    
    this.state = {
      signIn: '',
      appConfig: ''
    }

    this.logOut = this.logOut.bind(this);
  }

  componentDidMount(){
    this.cancellableSetting = makeCancellablePromise(
      getDocs(
        query(
          collection(db, 'setting'), limit(1)
        )
      )
    );

    this.cancellableSetting.promise.then((settingSnapshot) => {
      const settingData = settingSnapshot.docs[0].data(),
            yearNow = new Date().getFullYear();

      this.setState({
        appConfig: {
          test: '',
          url: settingData.settingUrl,
          dateFormat: settingData.settingDate,
          timeFormat: settingData.settingTime,
          dateTimeFormat: `${settingData.settingDate} - ${settingData.settingTime}`,
          currencyFormat: settingData.settingCurrency,
          thousandFormat: settingData.settingThousand,
          decimalFormat: settingData.settingDecimal,
          copy: settingData.settingCopyright === yearNow ? settingData.settingCopyright : settingData.settingCopyright + ' - ' + yearNow,
          safeMode: settingData.settingSafe,
        }
      });
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));
    });

    onAuthStateChanged(auth, (user) => {
      if(this.unsubscribe){
        this.unsubscribe();
      }

      if(user){
        this.cancellableUser = makeCancellablePromise(
          getDoc(
            doc(db, 'user', user.uid)
          )
        );

        this.cancellableUser.promise.then((userDoc) => {
          if(userDoc.exists()){
            const userData = userDoc.data();
            
            this.setState({
              signIn: true,
              dataUser: {
                uid: user.uid,
                name: userData.userName,
                email: userData.userEmail,
                phone: `${userData.userPhone.userPhoneCode}${userData.userPhone.userPhoneNumber}`,
              }
            });
          }else{
            toast.error(() => (<>Opps...<span>User not found.</span></>));
  
            this.logOut();
          }
        }).catch((error) => {
          console.error(error);
    
          toast.error(() => (<>{error.code}<span>{error.message}</span></>));
          
          this.logOut();
        });
      }else{
        this.setState({
          signIn: false,
          dataUser: '',
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.signIn !== prevState.signIn){
      if(prevState.signIn !== ''){
        if(this.state.dataUser.email){
          toast.success(() => (<>Sign In Successfully<span>Hi <strong>{this.state.dataUser.email}</strong>!</span></>));
        }else{
          toast.success(() => (<>Sign Out Successfully<span>Bye!</span></>));
        }
      }
    }
  }

  componentWillUnmount(){
    // if(this.cancellableSetting){
    //   this.cancellableSetting.cancel();
    // }

    if(this.unsubscribe){
      this.unsubscribe();
    }
    
    if(this.cancellableUser){
      this.cancellableUser.cancel();
    }
    
    if(this.cancellableLogout){
      this.cancellableLogout.cancel();
    }
  }

  logOut(){
    this.setState({ logOutLoading: true });

    this.cancellableLogout = makeCancellablePromise(signOut(auth));

    this.cancellableLogout.promise.then(() => {
      this.setState({ logOutLoading: false });
    }).catch((error) => {
      console.error(error);
      toast.error(() => (<>{error.code}<span>{error.message}</span></>));
    });
  }

  render(){
    // return (
    //   <Logo style={{display: 'block', margin: '0 auto', position: 'absolute', top: '50%', left: 0, right: 0, transform: 'translate(0, -50%)', maxWidth: '25%'}} />
    // );

    if(this.state.signIn === '' || this.state.appConfig === ''){
      return(
        <Loading text="Checking Authentication" page />
      );
    }else{
      return(
        <Suspense fallback={
          <Loading text="Loading" page />
        }>
          <Routes>
            <Route path="/login" element={
              this.state.signIn ? (<Navigate to="/admin" />) : (<Login appConfig={this.state.appConfig} />)
            } />
            <Route path="/admin/*" element={
              this.state.signIn ? (<Dashboard dataUser={this.state.dataUser} logOut={this.logOut} logOutLoading={this.state.logOutLoading} appConfig={this.state.appConfig} />) : (<Navigate to="/login" />)
            } />
            <Route path="*" element={
              this.state.signIn ? (<Navigate to="/admin" />) : (<Navigate to="/login" />)
            } />
          </Routes>
        </Suspense>
      );
    }
  }
}

export default App;
